// src/styles/GlobalStyles.ts
import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
const globalStyle = css`
/* Reset CSS */
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}
body {
  line-height: 1;
}
ol, ul {
  list-style: none;
}
blockquote, q {
  quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/* Base Styles */
html, body {
  height: 100%;
  margin: 0;
  font-family: 'Arial', sans-serif; /* グローバルなフォント設定を追加 */
}

#root {
  height: 100%;
  width: 100%;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Responsive Design */
@media (max-width: 1024px) {
  html, body {
    font-size: 90%; /* タブレット向けにフォントサイズを調整 */
  }
  #root {
    padding: 10px;
  }
}

@media (max-width: 768px) {
  html, body {
    font-size: 80%; /* スマートフォン向けにフォントサイズを調整 */
  }
  #root {
    padding: 5px;
  }
}

@media (max-width: 480px) {
  html, body {
    font-size: 70%; /* 小型スマートフォン向けにフォントサイズを調整 */
  }
  #root {
    padding: 2px;
  }
}
`

export const PageContainer = styled(motion.div)`
  padding: 0px 20px;
  color: #f0f0f0;
  max-width: 900px;
  margin: 0 auto;
  font-family: 'Arial', sans-serif; // これは GlobalStyles の body などで一括指定でもOK

  @media (max-width: 1024px) {
    max-width: 700px; /* タブレット向けに幅を調整 */
  }

  @media (max-width: 768px) {
    max-width: 500px; /* スマートフォン向けに幅を調整 */
  }

  @media (max-width: 480px) {
    max-width: 100%; /* 小型スマートフォン向けに幅を調整 */
    padding: 0 10px;
  }
`;

export const CommonPageTitle = styled.h1`
  font-size: 2.8em;
  text-align: center;
  margin-bottom: 40px;
  color: cyan;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);

  @media (max-width: 1024px) {
    font-size: 2.4em; /* タブレット向けにフォントサイズを調整 */
  }

  @media (max-width: 768px) {
    font-size: 2em; /* スマートフォン向けにフォントサイズを調整 */
  }

  @media (max-width: 480px) {
    font-size: 1.8em; /* 小型スマートフォン向けにフォントサイズを調整 */
  }
`;

export const IntroText = styled.p`
  font-size: 1.2em;
  font-weight: bold;
  color: #00e5ff;
  text-align: center;
  margin-bottom: 25px;
`;

export const SubHeading = styled.h3`
  font-size: 1.6em;
  color: #00cfcf;
  margin-top: 30px;
  margin-bottom: 15px;
  padding-bottom: 5px;
  border-bottom: 1px solid #007979;
`;

export const ContentParagraph = styled.p`
  font-size: 1.05em;
  margin-bottom: 18px;
  white-space: pre-wrap;
`;

export const EmphasisText = styled.strong`
  color: #fdd835;
  font-weight: bold;
`;

export const StyledList = styled.ul`
  list-style: none;
  padding-left: 0;
  margin-bottom: 20px;
`;

export const StyledListItem = styled.li`
  font-size: 1.05em;
  margin-bottom: 10px;
  padding-left: 25px;
  position: relative;
  &:before {
    content: '✔';
    color: #00bcd4;
    position: absolute;
    left: 0;
    font-size: 1.2em;
    font-weight: bold;
  }
`;

export const CallToActionText = styled.p`
  font-size: 1.15em;
  font-weight: bold;
  color: #81d4fa;
  text-align: center;
  margin-top: 30px;
`;


export default globalStyle;